module.exports = "/_next/static/images/placeholder-8362c015f15f1fd78a14017739e46f11.png";